import { createI18n } from 'vue-i18n';
import zhCN from './zh-CN.ts';
import enUS from './en-US.ts';

export const SUPPORTED_LOCALES = ['zh-CN', 'en-US'] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];
export const LOCALE_STORAGE_KEY = 'compass.locale';

function isSupported(value: string | null): value is AppLocale {
  return !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

function initialLocale(): AppLocale {
  try {
    const stored = globalThis.localStorage?.getItem(LOCALE_STORAGE_KEY) ?? null;
    if (isSupported(stored)) return stored;
  } catch {
    // Storage can be unavailable (private mode); fall back to the default locale.
  }
  return 'zh-CN';
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: initialLocale(),
  fallbackLocale: 'zh-CN',
  messages: { 'zh-CN': zhCN, 'en-US': enUS },
  missingWarn: false,
  fallbackWarn: false,
  missing: (locale, key) => {
    if (import.meta.env?.DEV) console.warn('[i18n] missing key:', key);
  },
});

export function setLocale(locale: AppLocale) {
  i18n.global.locale.value = locale;
  try {
    globalThis.localStorage?.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Persisting the preference is best-effort.
  }
  if (typeof document !== 'undefined') document.documentElement.lang = locale;
}

export default i18n;
